export const TOP_POST_LIST = [
  "CORS는 뭐고 왜 필요할까?.md",
  "Promise를 이용한 비동기 후속 처리.md",
  "Ajax : 서버와의 비동기적인 통신.md",
  "리액트가 가상 돔을 사용하는 이유.md",
  "한 페이지씩 전환되는 스크롤 구현기.md",
  "모바일에서 뷰포트 100vh 재계산하기 .md",
];

export const TOP_POST_DESCRIPTION = [
  "동일 출처 정책? 교차 출처 리소스 교환?",
  "Promise의 탄생 배경과 활용",
  "Fetch, Axios 이전의 XMLHTTPRequest",
  "리액트는 왜 Virtual DOM을 사용할까?",
  "원페이지 스크롤? 풀페이지 스크롤? 아무튼 구현해보자.",
  "왜 내 아이폰에서는 화면이 짤려서 나타나지?",
];
